export class WelcomeModal {
  constructor() {
    this.modal = document.getElementById('welcomeModal');
    this.closeBtn = document.getElementById('welcomeCloseBtn');

    if (!this.modal || !this.closeBtn) {
      console.error('Welcome modal elements not found');
      return;
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.closeBtn.addEventListener('click', () => this.hide());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.modal.style.display !== 'none') this.hide();
    });
  }

  hide() {
    this.modal.style.display = 'none';
  }
}